import React, { ReactNode, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useBoundStore } from "../store/store";
import { getAccessTokenInfo } from "data/user";

interface AuthRouteProps {
  children: ReactNode;
  type: any;
}

function AuthRoute({ type, children }: AuthRouteProps) {
  const { isAuthUser } = useBoundStore();
  const [status, setStatus] = useState<string | null>(null);
  const token = getAccessTokenInfo();
 

  useEffect(() => {
    const verifyToken = () => {
      try {
       
        setStatus("OK");
      } catch (err) {
        
        setStatus((err as Error).message);
      }
    };
    verifyToken();
  }, [token]);
  if (
    status?.startsWith("Invalid token specified: must be a string") ||
    status?.startsWith("Invalid token specified: invalid json") ||
    status?.startsWith("Invalid token specified: invalid base64") ||
    status?.startsWith("Invalid token specified: missing part") || Object.keys(token).length === 0
  ) {
    if (type === "private" || type === "admin") {
      
      return <Navigate to="/login" replace={true} />;
    } else {
      return <>{children}</>;
    }
  } else if (type === "guest" && isAuthUser && status === "OK") {
    return <Navigate to="/qualitymanagement" replace={true} />;
  } else {
    return <>{children}</>;
  }
}

export default AuthRoute;
